<template>
  <div>
    <v-datetime-picker
      v-model="datetime"
      :label="labelText"
      time-format="HH:mm"
      date-format="dd.MM.yyyy"

      :text-field-props="{
        outlined: cs.inputOutlined,
        filled: cs.inputFilled,
        dense: cs.inputDense,
        rounded: cs.inputRounded,
        backgroundColor: backgroundColor,
        hideDetails: true,
        class: 'mb-2',
        disabled: !field.canEdit
      }"
    />
  </div>
</template>

<script>
import moment from 'moment'
import sharedComputed from './../../computed'
import sharedMethods from './../../methods'
import formElementProps from './formElementProps'

export default {
  name: 'FormDateTime',

  data () {
    return {
      dateFormatted: null
    }
  },

  props: {
    ...formElementProps
  },

  computed: {
    ...sharedComputed,

    backgroundColor () {
      return this.fieldBackgroundColor(this.datetime, this.field)
    },

    computedDateFormatted () {
      return this.formatDate(this.value[this.field.fieldName])
    },

    datetime: {
      get: function () {
        return this.dateFormatted
      },
      set: function (value) {
        this.value[this.field.fieldName] = value ? moment(value).format() : null
      }
    }
  },

  methods: {
    ...sharedMethods,

    updateDateFormatted () {
      if (this.value[this.field.fieldName]) {
        this.dateFormatted = moment(this.value[this.field.fieldName]).format('DD.MM.YYYY HH:mm')
      }
    }
  },

  created () {
    this.updateDateFormatted()
  }
}
</script>
